import { SelectContext } from "@commonlibs";
import { DropdownItemRoot } from "./DropdownItem.styles";
import { DropdownItemProps } from "./DropdownItem.types";
import clsx from "clsx";
import { useContext } from "react";

export default function DropdownItem({ to = "", label, onClick, className, ...rest }: DropdownItemProps): JSX.Element {
    const { setOpen } = useContext(SelectContext);

    const handleMouseUp = () => setOpen(false);

    return (
        <DropdownItemRoot
            type={onClick ? "href" : "router"}
            onClick={onClick}
            onMouseUp={handleMouseUp}
            to={to}
            condition={Boolean(to)}
            className={clsx("SelectItem", "dropdown-item", className)}
            {...rest}
        >
            {label}
        </DropdownItemRoot>
    );
}
